import { PdfGen, PdfUnit, PdfSize, PdfRect } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

/**
 * Rada (Series) - Pattern recognition rows
 *
 * Layout: 1 portrait page, 10 rows.
 * Each row: a repeating pattern of images from a random series template,
 * plus an answer box at the right.
 *
 * Migrated from C# EduFrame.Img10.Generators.Rada
 */
export class Rada implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage();

    const margin = PdfUnit.FromMillimeters(10);
    const { origin, size } = calcOrigin(1, 10, margin, PdfSize.A4);

    const count = 9;
    const series = [
      [0, 1],
      [0, 0, 1, 1],
      [0, 1, 2],
      [0, 0, 1],
    ];

    // Generate pattern arrays
    const array: number[][] = [];
    for (let i = 0; i < 10; i++) {
      const sers = series[Math.floor(Math.random() * series.length)];
      const arr = Array.from({ length: opts.list.length }, (_, k) => k);
      // Shuffle arr
      for (let j = arr.length - 1; j > 0; j--) {
        const k = Math.floor(Math.random() * (j + 1));
        [arr[j], arr[k]] = [arr[k], arr[j]];
      }
      const row = Array.from({ length: count }, (_, j) => arr[sers[j % sers.length]]);
      array.push(row);
    }

    for (let i = 0; i < 10; i++) {
      const r1 = new PdfRect(
        origin.x,
        origin.y + size.height * i,
        size.width - size.height,
        size.height
      );
      const r2 = new PdfRect(
        origin.x + size.width - size.height,
        origin.y + size.height * i,
        size.height,
        size.height
      );

      const sz = Math.min(r1.width / count, size.height);

      for (let j = 0; j < count; j++) {
        const imgIndex = array[i][j];
        if (imgIndex < opts.list.length) {
          const r = new PdfRect(r1.left + j * sz, r1.top + (r1.height - sz) / 2, sz, sz);
          page.drawLabel(opts.list[imgIndex].left, { rect: r });
        }
      }

      page.drawRectangle(GUtil.basePen, null, r1);
      page.drawRectangle(GUtil.basePen, null, r2);
    }
  }
}
